module.exports = __webpack_public_path__ + "static/media/pulsations.156990a1.svg";